module.exports = __webpack_public_path__ + "img/chest.9776f809.png";